export interface IPagingRequestModel {
    PageNumber: number;
    PageSize: number;
    Filters: Record<string, string[]> | null;
    SortByColumn: string | null;
    IsSortDescending: boolean;
    SearchString?: string | null;
  }